/**
 * Open Graph locale tag (og:locale) for a short language code.
 */
export function localizedOgLocale (locale) {
  switch (locale) {
    case 'fa':
      return 'fa_IR'
    case 'nl':
      return 'nl_NL'
    case 'ar':
      return 'ar_SA'
    case 'pt':
      return 'pt_PT'
    case 'nb':
      return 'nb_NO'
    case 'sv':
      return 'sv_SE'
    case 'da':
      return 'da_DK'
    case 'it':
      return 'it_IT'
    case 'fr':
      return 'fr_FR'
    case 'de':
      return 'de_DE'
    case 'es':
      return 'es_ES'
    default:
      return 'en_US'
  }
}
